import { createFileRoute } from '@tanstack/react-router';
import { SSOConfigPage } from '@/components/settings/sso';

export const Route = createFileRoute('/_dashboard/admin/org/sso')({
  component: SSOSettingsPage,
});

function SSOSettingsPage() {
  return <SSOConfigPage />;
}
